module.exports = __webpack_public_path__ + "img/oops-bg.f7aaca37.jpg";